export default "__VITE_ASSET__614dfe6c__"